import styled from 'styled-components';

export const Body = styled.div`
  .muted {
    color: ${(props) => props.theme.$gray500};
  }

  .small-note {
    font-size: 0.82rem;
    margin: 8px 0 0;

    &.warn {
      color: ${(props) => props.theme.$gold};
    }
  }

  .drop-zone {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 32px 20px;
    border: 2px dashed ${(props) => props.theme.$gray300};
    border-radius: 12px;
    background: ${(props) => props.theme.$gray100};
    text-align: center;
    transition: border-color 0.15s, background 0.15s;

    &.dragging {
      border-color: ${(props) => props.theme.$primary_green};
      background: ${(props) => props.theme.$bg_green};
    }

    .drop-icon {
      width: 52px;
      height: 52px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${(props) => props.theme.$bg_green};
      color: ${(props) => props.theme.$primary_green};

      i {
        font-size: 28px;
      }
    }

    .drop-title {
      margin: 0;
      font-weight: 700;
      color: ${(props) => props.theme.$gray900};
    }

    .drop-sub {
      margin: 0 0 6px;
      font-size: 0.82rem;
      color: ${(props) => props.theme.$gray600};
    }

    .btn-ia {
      color: #fff;
      display: inline-flex;
      align-items: center;
      gap: 6px;

      i {
        font-size: 18px;
      }
    }
  }

  .tips {
    margin: 16px 0 0;
    padding-left: 18px;
    font-size: 0.84rem;
    color: ${(props) => props.theme.$gray600};

    li + li {
      margin-top: 4px;
    }
  }

  .reading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 32px 0;
    text-align: center;

    .reading-title {
      margin: 6px 0 0;
      font-weight: 500;
      color: ${(props) => props.theme.$gray900};

      small {
        color: ${(props) => props.theme.$gray500};
      }
    }

    .reading-sub {
      max-width: 420px;
      margin: 0 0 6px;
      font-size: 0.84rem;
      color: ${(props) => props.theme.$gray600};
    }
  }

  .review-summary {
    padding: 12px 14px;
    margin-bottom: 12px;
    border: 1px solid ${(props) => props.theme.$secondary_green_light};
    border-radius: 10px;
    background: ${(props) => props.theme.$bg_green};

    p {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 0 0 6px;
      color: ${(props) => props.theme.$gray800};

      i {
        font-size: 18px;
        color: ${(props) => props.theme.$primary_green};
      }
    }

    .columns {
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
      font-size: 0.78rem;
      color: ${(props) => props.theme.$dark_green};

      i {
        font-size: 14px;
        vertical-align: -2px;
        margin-right: 2px;
      }
    }

    .column-chip {
      padding: 1px 8px;
      border-radius: 6px;
      background: #fff;
      color: ${(props) => props.theme.$gray700};
    }
  }

  .alert {
    font-size: 0.84rem;
    padding: 8px 12px;
    margin-bottom: 10px;
  }

  .ignored {
    margin-bottom: 12px;
    padding: 10px 14px;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;
    font-size: 0.84rem;

    summary {
      cursor: pointer;
      color: ${(props) => props.theme.$gray700};
      font-weight: 500;
    }

    ul {
      margin: 10px 0 0;
      padding: 0;
      list-style: none;
    }

    li {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      gap: 12px;

      & + li {
        margin-top: 6px;
      }
    }
  }

  .review-table {
    max-height: 46vh;
    overflow: auto;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 10px;

    thead th {
      position: sticky;
      top: 0;
      z-index: 1;
      background: ${(props) => props.theme.$gray100};
      font-size: 0.72rem;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: ${(props) => props.theme.$gray600};
      border-top: 0;
      vertical-align: middle;
    }

    td {
      vertical-align: top;
      font-size: 0.85rem;

      &.muted {
        padding-top: 13px;
      }

      input[type='checkbox'] {
        margin-top: 9px;
      }
    }

    tr.excluded td {
      opacity: 0.45;
    }

    textarea {
      resize: vertical;
      font-size: 0.85rem;
    }

    .row-extra {
      margin: 3px 0 0;
      font-size: 0.74rem;
      color: ${(props) => props.theme.$gray500};
    }

    .row-alert {
      display: flex;
      align-items: flex-start;
      gap: 3px;
      margin: 3px 0 0;
      font-size: 0.74rem;
      color: ${(props) => props.theme.$gold};

      i {
        font-size: 14px;
      }
    }

    .icon-btn {
      border: 0;
      background: transparent;
      color: ${(props) => props.theme.$gray500};
      padding: 2px;

      &:hover {
        color: ${(props) => props.theme.$danger};
      }

      i {
        font-size: 18px;
      }
    }
  }
`;
